import { useMemo } from 'react'
import { useReselector } from '@/utils/sharedHooks'
import { selectAdminOrUserGroupedFinancialAccountOptions } from '@/selectors/financeSelectors'
import { getCurrentUser } from '@/selectors/user.selectors'
import { useGroupedDropdownLabel } from '@/components/groupedDropdownHelpers'
import { UserDocument } from '../lib/userDocuments.slice'
import { Table } from '@/ui'

interface FinancialAccountCellProps {
  document: UserDocument
}

export const MultipleFinancialAccountCell = ({
  document,
}: FinancialAccountCellProps) => {
  const user = useReselector(getCurrentUser)

  const financialAccountOptions = useReselector(
    selectAdminOrUserGroupedFinancialAccountOptions,
    user?.id
  )

  const statementAccountIds = useMemo(() => {
    const statementAccounts =
      document.statement?.statementFinancialAccounts || []
    if (!statementAccounts.length) return []
    return statementAccounts.map((statement) => statement.financialAccountId)
  }, [document.statement])

  const { text } = useGroupedDropdownLabel(
    statementAccountIds,
    financialAccountOptions
  )

  return (
    <Table.Cell>
      <b>{document.id !== -1 && text}</b>
    </Table.Cell>
  )
}
